import React from 'react';
import PropTypes from 'prop-types';
import A11ySvg from 'components/A11ySvg';
import './WindCreekIcon.css';

const WindCreekIcon = ({ className, alt = 'Wind Creek W Logo' }) => {
  return (
    <A11ySvg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-2 0 34.49 30.46"
      className={className}
      alt={alt}
    >
      <path d="M28,6.83A15.52,15.52,0,0,0,23.4,2.34c-6.69,5.2-9.81,14.6-10,15.12A41.8,41.8,0,0,0,16.34,28c2-10.7,6.87-17.27,11.63-21.14" />
      <path d="M17.9,27.67c-.18.85-.37,1.75-.56,2.6l0,.07A15.2,15.2,0,0,0,28.56,7.84c-3.94,3.34-8.28,9.28-10.66,19.83" />
      <path d="M12.18,22.69a30.54,30.54,0,0,0-.3,4.27c-.07.26-1.11.78-1.93,1.27C4.83,17.83,5.09,8.13,5.46,6.91A9.33,9.33,0,0,1,7.28,5.42a39.31,39.31,0,0,0,3.27,18.5c.3-1.63.67-3.45,1.07-4.86-1-7.24.38-11.44.49-11.59a14.23,14.23,0,0,1,1.67-1.11,25.74,25.74,0,0,0-.6,8C15.71,8.17,18.79,4.16,22,1.56A15.06,15.06,0,0,0,15.27,0a15.23,15.23,0,0,0-.34,30.45,68.06,68.06,0,0,1-2.75-7.76" />
    </A11ySvg>
  );
};

export default WindCreekIcon;

WindCreekIcon.propTypes = {
  className: PropTypes.string
};
